import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=b7cea170&scoped=true"
import script from "./groupDetail.vue?vue&type=script&lang=js"
export * from "./groupDetail.vue?vue&type=script&lang=js"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=b7cea170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cea170",
  null
  
)

export default component.exports